import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import MKBox from "components/MKBox";
import footerRoutes from "footer.routes";
import ActionsOverview from "./sections/ActionsOverview";
import DefaultFooter from "components/DefaultFooter";
import ChatsOverview from "./sections/ChatsOverview";
import { ChatsAdminProvider } from "./contexts/ChatsAdminContext";
import ContainerCard from "components/ContainerCard";
import Breadcrumbs from "examples/Breadcrumbs";
import Container from "@mui/material/Container";

function ChatsDatabase() {
  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />
      <ContainerCard>
        <Container>
          <Breadcrumbs
            routes={[{ label: "Admin", route: "/admin" }, { label: "Chats Database" }]}
          />
        </Container>
        <ChatsAdminProvider>
          <ChatsOverview />
          <ActionsOverview />
        </ChatsAdminProvider>
      </ContainerCard>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ChatsDatabase;
